import { useContext, useReducer, useEffect } from "react";
import { reducer, actions, initialState } from "./reducer";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import { ParagraphTextColor } from "utils";
import { AiOutlineUser } from "react-icons/ai";
import { FiSettings } from "react-icons/fi";
import { IoIosNotifications } from "react-icons/io";
import "./styles.scss";
import { SocketContext } from "routers";
import { callApi } from "api";

const Container = styled.div`
  background-color: ${(props) => props.theme.dashboard.navbar.background};
`;
export const DashboardNavbar = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const location = useLocation();
  const { pathname } = useLocation();
  // * Token
  const { token } = JSON.parse(localStorage.getItem("userInfo")) || {};
  const history = useHistory();
  const { role } = JSON.parse(localStorage.getItem("userInfo")) || {};

  useEffect(() => {
    const getNotifications = () => {
      callApi(
        "/api/notifications/getAllFromUserUnRead/",
        "GET",
        null,
        {
          REQUEST: actions.GET_NOTIFICATIONS,
          SUCCESS: actions.GET_NOTIFICATIONS_SUCCESS,
          FAILURE: actions.GET_NOTIFICATIONS_FAILURE,
        },
        dispatch,
        false,
        token
      );
    };
    getNotifications();
  }, [pathname]);
  return (
    <Container className="dashboard__navbar">
      <ParagraphTextColor className="dashboard__navbar__title">
        Dashboard
      </ParagraphTextColor>
      <div className="navbar__right">
        <div className="navbar__notifications">
          {state.getNotifications.success && (
            <div className="navbar__notifications__icon">
              <span>{state.getNotifications.data?.length}</span>
            </div>
          )}
          <IoIosNotifications
            onClick={() => history.push("/dashboard/notificaciones")}
          />
        </div>
        <AiOutlineUser
          onClick={() => history.push("/dashboard/editar-perfil")}
        />
        {role === "admin" && (
          <FiSettings
            onClick={() => history.push("/dashboard/configuracion")}
          />
        )}
        <ParagraphTextColor
          className="dashboard__navbar__subtitle"
          onClick={() => {
            localStorage.removeItem("userInfo");
            history.push("/");
            window.location.reload();
          }}
        >
          Cerrar sesión
        </ParagraphTextColor>
      </div>
    </Container>
  );
};
